var TEMPLATE_URL = require('./gallery.item.html');

angular.module('ikeweb.spike.gallery').directive('galleryItem', ['$translate', function($translate) {

    function setSelectable($scope, $element, $attrs) {
        if ($attrs.notselectable !== undefined) {
            $scope.notselectable = true;
            $element.addClass('GalleryItem--noborder');
            $element.addClass('GalleryItem--shadowborder');
        }
    }

    function setDraggable($element, capture) {
        $element
            .data('capture', capture)
            .draggable({
                revert: 'invalid',
                helper: function() {

                    var newElement = $element.clone()
                        .find('.GalleryItem-cover, .GalleryItem-dragHandle')
                        .remove()
                        .end()
                        .addClass('GalleryItem-dragging')
                        .width($element.width())
                        .height($element.height())
                        .data('dropped', false);

                    var elements = $('.GalleryItem--selected');
                    if (elements.length > 0) {
                        var description = $('<div>' + elements.length + ' ' + $translate.instant('COMPONENT.GALLERY_ITEM.CAPTURES') + '</div>');
                        description.addClass('GalleryItem-title');
                        var title = newElement.find('.GalleryItem-title');
                        title.html(description); // change the title to reflect number of captures
                    }

                    newElement.css('zIndex', $element.css('zIndex'));
                    return newElement;
                },
                handle: '.GalleryItem-dragHandle',
                appendTo: 'body',
                containment: 'parent',
                distance: 0,
                delay: 0,
                cursorAt: {
                    left: 12,
                    top: 10
                },
                start: function() {
                    $('.GalleryItem--selected').each(function(i, el) {
                        $(el).fadeTo(200, 0.5);
                    });
                    // select all elements that are selected, fade them
                    // take the count of selected elements
                },
                stop: function(evt, ui) {
                    $('.GalleryItem--selected').each(function(i, el) {
                        $(el).fadeTo(200, 1);
                    });
                }
            });
    }

    function setInputKeybind($element) {
        var $input = $element.find('.GalleryItem-captureName');
        $input
            .bind('keypress', function(event) {
                if (event.which === 13) {
                    $input.blur();
                }
            })
            .bind('dblclick', function() {
                $input.select();
            });
    }

    return {
        restrict: 'E',
        controller: 'GalleryItemController',
        controllerAs: 'ctrl',
        replace: true,
        templateUrl: TEMPLATE_URL,
        scope: {
            capture: '=',
            visibleEvent: '@'
        },
        link: function($scope, $element, $attrs, ctrl) {
            $scope.isReadOnly = true;
            $scope.notdraggable = $attrs.notdraggable !== undefined;

            setSelectable($scope, $element, $attrs);
            setInputKeybind($element);

            if (!$scope.notdraggable) {
                setDraggable($element, $scope.capture);
            }

            ctrl.blurInput = function() {
                $element.find('.GalleryItem-captureName').blur();
            };
        }
    };
}]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/gallery/item/gallery.item.directive.js
// module id = 527
// module chunks = 0